import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { PreviewTermPlanModel } from '../models/preview_term_plan_model';
import { VerifyPreviewPlanData } from './../validators/verify_preview_plan_data';
angular
  .module('capability-ng-academic-planner')
  .service(
    'loadTermPreviewPlanCommand',
    function loadTermPreviewPlanCommand(
      $http: ng.IHttpService,
      log: any,
      ngPreviewTermPlanModel: PreviewTermPlanModel,
      ngAPVerifyPreviewPlanData: VerifyPreviewPlanData,
      defineCommandORM: IDefineCommand,
      ngAPNotificationDelegate: INotificationDelegate
    ) {
      return defineCommandORM(
        'loadTermPreviewPlanCommand',
        (deferred, termCommitment: string, termPreference: string, generatePlan: boolean = true) => {
          $http
            .post(`academicplan/quickplan/`, {
              time_commitment: termCommitment,
              term_preference: termPreference,
              generate_plan: generatePlan,
              choose_planned_course_groups: false
            })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngPreviewTermPlanModel.clear().write(data);
              if (_4.isEmpty(data.student_planned_terms)) {
                ngAPNotificationDelegate.error(`Unable to generate template as no term data is available`);
              }
              if (_4.isEmpty(data.planned_courses)) {
                ngAPNotificationDelegate.error(`Unable to generate template as no course data is available`);
              }
            })
            .then(() => deferred.resolve())
            .catch((e: string) => {
              log.error(e);
              ngAPNotificationDelegate.error(`Unable to load preview.`);
              deferred.reject(e);
            })
            .finally(() => ngAPVerifyPreviewPlanData.verify());
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/commands/load_term_preview_plan_command.ts